var touchStart, touchMove, touchEnd, touchCancel;
var cardview = {
	current: 0,
	max: 0,
	flag: true,
	data: [],
	jsonName: "",
	jsonURL: "", //htmlの名前から取得
	init: function(){
		//LOADING START
		console.log("%cCardview init", 'color: #f54b00');
		if( $("body").hasClass("is_cardview") ){
			$("#deck_cardview").removeClass("disable");
			cardview.resize();
			startCardView();
		}else{
			//別ページから来た
			loadPage.loadCardView().done(function(){
				cardview.current = 0;
				cardview.resize();
				startCardView();
			});
		}
		function startCardView(){
			console.log("start card view")
			cardview.max 		= $("#deckslideshow ul.slideshow_img li").length;
			$(".header_decks_detail .num_max").html(cardview.max);
			$(".header_decks_detail .num_current").html(cardview.current+1);
			//loadPage.overrideTitle();
			cardview.resize();
			
			gMap.init($("#deckslideshow .slideshow_img li").eq(0).attr("data-lat"), $("#deckslideshow .slideshow_img li").eq(0).attr("data-lng"), ".map_main");
			//全てのスポットが一画面に入るようにフィットさせる
			let listHTML = "";
			$("#deckslideshow .slideshow_img li").each(function(i){
				let lat = $(this).attr("data-lat");
				let lng = $(this).attr("data-lng");
				let title 	= $(".slideshow_txt li").eq(i).find("h4").text();
				let url 	= $(".slideshow_txt li").eq(i).find("a.deck_to_spot").attr("href");
				gMap.addSpot(lat, lng, ".map_main", i, "spot");
				listHTML += '<li><a href="javascript:void(0);" data-num="' + i + '" data-url="' + url + '" data-title="' + title + '"><figure style="background-image: url(' + $(this).attr("data-img") + ');"></figure></a></li>';
			});
			$(".nav_map .list_spot_map ul").html(listHTML);
			if(fw.isFirst){
				fw.isFirst = false;
			}
			if(page.param === "map"){
				gMap.activeSpot(true);
				cardview.change();
				$("body").addClass("is_mapview");
				gMap.nav();
			}else{
				if(cardview.current != 0){

				}else{
					cardview.current = 0;
				}
				cardview.change();
			}
			
			if( !$("body").hasClass("scroll_deck")){
				//トップからデッキに来た場合、scroll_deckが先につくとレイアウトが崩れるため、分岐
				setTimeout(function(){
					fw.afterChangePage();
				},600);
			}else{
				fw.afterChangePage();
				$("#btn_back").removeClass("disable");
			}
			
		}
	},
	hide: function(){
		if( $body.hasClass("is_cardview") ){
			console.log("%cCardview hide", 'color: #f54b00');
			let posY = $(document).scrollTop()*-1;
			$('#deck_cardview #load_cardview').css("transform", "translate3d(0, " + posY + "px, 0)");
			
			$("#deck_cardview").removeClass("scroll");
			$("#deck_cardview").removeClass("show");
			setTimeout(function(){
				$body.removeClass("is_cardview");
				//$body.removeClass("scroll_deck");
				$body.removeClass("is_mapview");
				setTimeout(function(){
					$('#deck_cardview #load_cardview').css("transform", "");
				}, 100);
			}, 400);
		}
	},
	show: function(){
		//$("#search_layer_deck").removeClass("show");
		$("#deck_cardview").addClass("show");
		
		setTimeout(function(){
			common.scrollToPosition(0, 50);
			setTimeout(function(){
				$body.addClass("is_cardview");
				$("#deck_cardview").addClass("scroll");
				$("#deck_cardview").removeClass("disable");
			},100)
		}, 500);
	},
	resize: function(){
		$("#deckslideshow ul.slideshow_img li").each(function(i){
			let z = $("#deckslideshow ul.slideshow_img li").length - i;
			$(this).css({
				"z-index": z
			});
		});
	},
	nav: function(){
		//console.log("%cCardview nav", 'color: #f54b00');
		//for smartphone touch event
		$("a#btn_cardview_prev").off().on("click", function(){
			cardview.dec();
		});
		$("a#btn_cardview_next").off().on("click", function(){
			cardview.inc();
		});
		$("a.btn_map").off().on("click", function(){
			let idx = parseInt( $(this).attr("data-num") );
			cardview.current = idx;
			gMap.activeSpot(true);
			let path 	= location.pathname + "?map";
			let spotURL = $("#deckslideshow .slideshow_txt li").eq( parseInt($(this).attr("data-num")) ).find("a.deck_to_spot").attr("href");
			let urlArry = spotURL.split("/");
			common.sendEvent( "deck_map:spot:" + urlArry[urlArry.length-1], location.pathname + "?map");
			fw.changeURL(path);
		});
		$("a.btn_close_map").off().on("click", function(){
			let path = location.pathname;
			fw.changeURL(path);
		});
		
		var cx, positionX, limitX = 80, touchIdx;
		let $touchBlock = $("#deckslideshow")[0];
		
		touchStart = { name: 'start', handleEvent: function(e){
			if(!cardview.flag){ return false;}
			$("#deckslideshow").addClass("notransition");
			cx 			= 0;
			positionX 	= getPosition(e);
		}};
		touchMove = { name: 'move', handleEvent: function(e){
			cx 	= positionX - getPosition(e);
			let left = cx;
		}};
		touchEnd = { name: 'end', handleEvent: function(e){
			if(cardview.current > cardview.max-1){
				cardview.resetPosition();
			}else{
				if(cx <= -limitX){
					cardview.dec();
				}else if(cx >= limitX){
					cardview.inc();
				}else{
					cardview.resetPosition();
				}
			}
		}}
		touchCancel = { name: 'cancel', handleEvent: function(e){
			cx = 0;
			cardview.resetPosition();
			cardview.flag = true;
		}}
		
		
		$touchBlock.addEventListener("touchstart", touchStart, { passive: true});
		$touchBlock.addEventListener("touchmove", touchMove, { passive: true });
		$touchBlock.addEventListener("touchend", touchEnd, { passive: true});
		$touchBlock.addEventListener("touchcancel", touchCancel, { passive: true });
		function getPosition(event){
			return event.touches[0].pageX;
		}
	},
	resetPosition: function(){
		$("#deckslideshow").removeClass("notransition");
		$("#deckslideshow li").eq(cardview.current).css({
			"transform": ""
		});
		$("#deckslideshow li").eq(cardview.current-1).css({
			"transform": ""
		});
	},
	inc: function(){
		if(cardview.flag){
			cardview.flag = false;
			cardview.current++;
			if(cardview.current >= cardview.max){
				cardview.current = cardview.max-1;
				cardview.flag = true;
				cardview.resetPosition();
			}else{
				cardview.change();
			}
		}
	},
	dec: function(){
		if(cardview.flag){
			cardview.flag = false;
			cardview.current--;
			if(cardview.current < 0){
				cardview.current = 0;
				cardview.flag = true;
				cardview.resetPosition();
			}else{
				cardview.change();
			}
		}
	},
	change: function(){
		let consoleTEXT = "%c" + cardview.current + " / " + cardview.max;
		//console.log(consoleTEXT, 'color: #f54b00');
		cardview.resetPosition();
		$(".header_decks_detail .num_current").html(cardview.current+1);
		
		$("#deckslideshow ul.slideshow_img li").each(function(i){
			let $this = $(this);
			if(i < cardview.current){
				$this.addClass("disable");
			}else{
				if($this.hasClass("disable")){
					$this.removeClass("disable");
				}
			}
			if(i === cardview.current){
				$this.addClass("active");
			}else if(i > cardview.current){
				$this.removeClass("active");
			}
		});
		let _h = $(".slideshow_txt li").eq(cardview.current).outerHeight();
		$(".slideshow_txt").css({
			"height": _h + "px"
		});
		$("#deckslideshow").removeClass();
		let cls = "current" + cardview.current;
		$("#deckslideshow").addClass(cls);


		if(cardview.current === 0){
			$("#btn_cardview_prev").addClass("disable");
			$("#btn_cardview_next").removeClass("disable");
		}else if(cardview.current === cardview.max-1){
			$("#btn_cardview_prev").removeClass("disable");
			$("#btn_cardview_next").addClass("disable");
		}else{
			$("#btn_cardview_prev").removeClass("disable");
			$("#btn_cardview_next").removeClass("disable");
		}
		if(cardview.max === 1){
			$("#btn_cardview_next").addClass("disable");
		}
		setTimeout(function(){
			cardview.flag = true;
		}, 400);
		let $touchBlock = $("#deckslideshow")[0];
		$touchBlock.removeEventListener("touchstart", touchStart, { passive: true });
		$touchBlock.removeEventListener("touchmove", touchMove, { passive: true });
		$touchBlock.removeEventListener("touchend", touchEnd, { passive: true });
		$touchBlock.removeEventListener("touchcancel", touchCancel, { passive: true});
		cardview.nav();
	}
}